module.exports = __webpack_public_path__ + "static/media/ceuso.9fd03e67.png";